const Teamdata=[
    {
        teamimg:'./Images/team1.jpg',

    },
    {
        teamimg:'./Images/team2.jpg',

    },
    {
        teamimg:'./Images/team3.jpg',

    },
    {
        teamimg:'./Images/team4.jpg',

    },
    {
        teamimg:'./Images/team5.jpg',

    },
    {
        teamimg:'./Images/team6.jpg',

    }
]
export default Teamdata